/**
 * Resolve Shopify native bundle component SKUs via Storefront API for eTrusted widgets.
 * Requires theme setting: eTrusted → Storefront API access token.
 */
(function () {
  var config = window.__etrustedBundleApi;
  if (!config || !config.token) return;

  var API_VERSION = config.apiVersion || '2024-07';
  var ENDPOINT = 'https://' + config.domain + '/api/' + API_VERSION + '/graphql.json';
  var THEME_WIDGET_SELECTOR =
    'etrusted-widget[data-etrusted-widget-id="wdg-6a7492b2-a2f6-4245-9bbf-f2bef544ef7e"]';
  var skuCache = Object.create(null);
  var VARIANT_FRAGMENT = [
    'fragment BundleVariant on ProductVariant {',
    '  requiresComponents',
    '  components(first: 25) {',
    '    nodes {',
    '      productVariant {',
    '        sku',
    '      }',
    '    }',
    '  }',
    '}',
  ].join('\n');

  function normalizeVariantId(variantId) {
    return variantId == null ? '' : String(variantId).trim();
  }

  function variantGid(variantId) {
    return 'gid://shopify/ProductVariant/' + variantId;
  }

  function collectSkus(variantNode) {
    if (!variantNode || !variantNode.components || !variantNode.components.nodes) return '';

    var skus = [];
    var seen = Object.create(null);

    variantNode.components.nodes.forEach(function (component) {
      var sku = component && component.productVariant && component.productVariant.sku;
      if (!sku || seen[sku]) return;
      seen[sku] = true;
      skus.push(sku);
    });

    return skus.join(',');
  }

  function buildBatchQuery(variantIds) {
    var variables = {};
    var variableDefs = [];
    var nodeFields = [];

    variantIds.forEach(function (variantId, index) {
      var key = 'id' + index;
      variableDefs.push('$' + key + ': ID!');
      variables[key] = variantGid(variantId);
      nodeFields.push(
        'v' + index + ': node(id: $' + key + ') { ... on ProductVariant { ...BundleVariant } }'
      );
    });

    return {
      query: [
        VARIANT_FRAGMENT,
        'query BatchBundleComponents(' + variableDefs.join(', ') + ') {',
        nodeFields.join('\n'),
        '}',
      ].join('\n'),
      variables: variables,
    };
  }

  function storefrontRequest(body) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.token,
      },
      body: JSON.stringify(body),
    }).then(function (response) {
      if (!response.ok) throw new Error('Storefront API request failed: ' + response.status);
      return response.json();
    });
  }

  function fetchBundleSkus(variantIds) {
    var pending = [];
    var results = Object.create(null);

    variantIds.forEach(function (variantId) {
      var normalizedId = normalizeVariantId(variantId);
      if (!normalizedId) return;

      if (skuCache[normalizedId]) {
        results[normalizedId] = skuCache[normalizedId];
        return;
      }

      if (pending.indexOf(normalizedId) === -1) {
        pending.push(normalizedId);
      }
    });

    if (!pending.length) {
      return Promise.resolve(results);
    }

    return storefrontRequest(buildBatchQuery(pending)).then(function (payload) {
      if (payload.errors && payload.errors.length) {
        console.error('[eTrusted bundle SKUs] GraphQL errors:', payload.errors);
      }

      var data = payload.data || {};

      pending.forEach(function (variantId, index) {
        var node = data['v' + index];
        var skus = collectSkus(node);
        skuCache[variantId] = skus;
        results[variantId] = skus;
      });

      return results;
    });
  }

  function replaceWidgetElement(widget) {
    var parent = widget.parentNode;
    if (!parent) return widget;

    var replacement = document.createElement('etrusted-widget');
    Array.prototype.slice.call(widget.attributes).forEach(function (attr) {
      if (attr.name === 'data-etrusted-resolve-bundle' || attr.name === 'hidden') return;
      replacement.setAttribute(attr.name, attr.value);
    });

    parent.replaceChild(replacement, widget);
    return replacement;
  }

  function revealWidgetContainer(widget) {
    var container = widget.closest('.etrusted-product-widget, .etrusted-product-card-rating, .etrusted-product-star');
    if (container) container.classList.remove('etrusted-widget--awaiting-skus');

    var reservoir = document.getElementById('etrusted-pdp-widget-reservoir');
    if (reservoir) reservoir.removeAttribute('hidden');
  }

  function applySkusToWidgets(skuMap) {
    var widgets = document.querySelectorAll('etrusted-widget[data-etrusted-resolve-bundle]');
    var applied = 0;

    widgets.forEach(function (widget) {
      var variantId = normalizeVariantId(widget.getAttribute('data-etrusted-variant-id'));
      var skus = variantId ? skuMap[variantId] : '';

      if (!skus) {
        console.warn('[eTrusted bundle SKUs] No component SKUs for variant', variantId || '(missing)');
        return;
      }

      widget.setAttribute('data-sku', skus);
      widget.removeAttribute('data-etrusted-resolve-bundle');
      widget.removeAttribute('hidden');
      revealWidgetContainer(widget);
      replaceWidgetElement(widget);
      applied += 1;
    });

    document.querySelectorAll('[data-etrusted-await-bundle]').forEach(function (node) {
      node.hidden = false;
      node.removeAttribute('data-etrusted-await-bundle');
    });

    return applied;
  }

  function hasReadyThemeWidget() {
    var widgets = document.querySelectorAll('etrusted-widget[data-sku]');
    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].getAttribute('data-sku')) return true;
    }
    return false;
  }

  function hasAnyEtrustedWidget() {
    return document.querySelectorAll('etrusted-widget').length > 0;
  }

  function hasPendingBundleWidgets() {
    return document.querySelectorAll('etrusted-widget[data-etrusted-resolve-bundle]').length > 0;
  }

  function shouldBootstrapWidgets() {
    if (hasReadyThemeWidget()) return true;
    if (hasPendingBundleWidgets()) return false;

    return hasAnyEtrustedWidget();
  }

  function ensureWidgetBootstrap() {
    if (window.__etrustedWidgetBootstrapRequested) return;
    if (!shouldBootstrapWidgets()) return;

    window.__etrustedWidgetBootstrapRequested = true;

    var script = document.createElement('script');
    script.src = 'https://integrations.etrusted.com/applications/widget.js/v2';
    script.defer = true;
    script.async = true;
    script.onload = function () {
      window.dispatchEvent(new CustomEvent('etrusted:widget-js-ready'));
    };
    document.head.appendChild(script);
  }

  function notifyBundleSkusReady() {
    if (typeof window.__etrustedPlacePdpWidget === 'function') {
      window.__etrustedPlacePdpWidget(true);
    }

    window.dispatchEvent(new CustomEvent('etrusted:bundle-skus-ready'));
  }

  function finishBundleResolution(appliedCount) {
    notifyBundleSkusReady();

    if (appliedCount > 0 || shouldBootstrapWidgets()) {
      requestAnimationFrame(function () {
        requestAnimationFrame(ensureWidgetBootstrap);
      });
    }
  }

  function collectPendingVariantIds() {
    var variantIds = [];

    document.querySelectorAll('etrusted-widget[data-etrusted-resolve-bundle]').forEach(function (widget) {
      var variantId = normalizeVariantId(widget.getAttribute('data-etrusted-variant-id'));
      if (variantId && variantIds.indexOf(variantId) === -1) {
        variantIds.push(variantId);
      }
    });

    return variantIds;
  }

  function resolveBundleWidgets() {
    var variantIds = collectPendingVariantIds();

    if (!variantIds.length) {
      finishBundleResolution(0);
      return Promise.resolve();
    }

    return fetchBundleSkus(variantIds)
      .then(function (skuMap) {
        return applySkusToWidgets(skuMap);
      })
      .catch(function (error) {
        console.warn('[eTrusted bundle SKUs]', error);
        return 0;
      })
      .then(finishBundleResolution);
  }

  window.__etrustedResolveBundleSkus = resolveBundleWidgets;

  if (typeof window.__etrustedPlacePdpWidget === 'function') {
    window.__etrustedPlacePdpWidget(true);
  }

  resolveBundleWidgets();
})();
